import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {ArrowRightAlt as ArrowRightAltIcon, Schedule as ScheduledAtIcon} from "@mui/icons-material";
import {formatTimestamp} from "../../../../../../utils/datetime";
import ContentBox from "./ContentBox";

interface FirmwareChangeScheduledContentType {
    targetFirmwareId?: string;
    targetFirmwareVersion?: string;
    scheduledAt?: string;
}

export interface FirmwareUpdateScheduledContentProps {
    content: string;
}

export default function FirmwareUpdateScheduledContent({content}: FirmwareUpdateScheduledContentProps) {
    const {t} = useTranslation();
    const contentTyped = JSON.parse(content) as FirmwareChangeScheduledContentType;
    contentTyped.scheduledAt = formatTimestamp(contentTyped.scheduledAt);
    return (
        <Stack
            title={`${t("generic_firmware")}: → ${contentTyped.targetFirmwareVersion || ""} (@${
                contentTyped.scheduledAt
            })`}
        >
            <Stack direction="row">
                <ScheduledAtIcon fontSize="small" />
                <ContentBox>{contentTyped.scheduledAt}</ContentBox>
            </Stack>
            <Stack direction="row">
                <ArrowRightAltIcon fontSize="small" />
                <ContentBox>{contentTyped.targetFirmwareVersion}</ContentBox>
            </Stack>
        </Stack>
    );
}
